/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { UserList } from './user-list';
import { mapDispatchToProps, mapStateToProps } from './user-list-utils';
export default connect(mapStateToProps, mapDispatchToProps)(UserList);
